import EvStationIcon from '@mui/icons-material/EvStation';
import { PERMISSIONS } from '../../constants';
import list from './ListInchargeStation';
import create from './CreateInchargeStation';
import edit from './EditInchargeStation';

export default {
  list,
  create,
  edit,
  name: 'chains/chainId/incharge-stations',
  options: { label: 'Carregadores elétricos' },
  icon: EvStationIcon,
  // Reusa a permissão de posto: quem configura posto configura o carregador dele. Permissão
  // nova exigiria seed no banco e reatribuição em todos os perfis antes da tela abrir.
  permissions: [PERMISSIONS.LIST_STATION],
};
